export default __webpack_public_path__ + "static/media/work9.c456bb6f.png";